export default "__VITE_ASSET__BWBESuwK__"